module.exports = __webpack_public_path__ + "static/media/bg.eef2daf9.jpg";